import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './styles/global.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ParceriaRestaurantes from './landing-pages/parceria-restaurantes';
import TodosNiveisDeEnsino from './landing-pages/todos-niveis-de-ensino';
import TagManager from 'react-gtm-module';

// Initialize Google Tag Manager
const tagManagerArgs = {
  gtmId: 'GTM-MXF9D5X'
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/parceria-restaurantes/*" element={<ParceriaRestaurantes />} />
        <Route path="/todos-niveis-de-ensino/*" element={<TodosNiveisDeEnsino />} />
        <Route path="/" element={<div>Home Page</div>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
